enum FileUsageType {
    GTC = 'GTC',
    GDPR = 'GDPR',
    EXCEL_TEMPLATE = 'EXCEL_TEMPLATE',
}

export default FileUsageType;
